var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row page-row report"},[_c('div',{staticClass:"col-sm-12"},[_c('h1',[_vm._v("Under construction")])])])
}]

export { render, staticRenderFns }